/* Accessible marketing navigation; no framework required. */
(function () {
    var button = document.querySelector('.menu-button');
    var nav = document.querySelector('.site-nav');
    if (!button || !nav) return;
    function close() { nav.classList.remove('site-nav--open'); button.setAttribute('aria-expanded', 'false'); }
    button.addEventListener('click', function () { var open = button.getAttribute('aria-expanded') !== 'true'; nav.classList.toggle('site-nav--open', open); button.setAttribute('aria-expanded', String(open)); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') { close(); button.focus(); } });
    document.addEventListener('click', function (event) { if (!event.target.closest('.site-header')) close(); });
    nav.addEventListener('click', function (event) { if (event.target.closest('a')) close(); });
    window.matchMedia('(max-width: 780px)').addEventListener('change', close);
})();
